import CrownIcon from 'assets/Icons/CrownIcon';
import React from 'react';
import { useRecoilValue } from 'recoil';

import { ShouldRender } from '@/components/shared/basic/ShouldRender';

import { getGlobalCountry } from '@/atoms/countryState';
import { user } from '@/atoms/user';
import { isPlatformSubscriptionActive } from '@/utils/index';
import { User } from '@/utils/interfaces/User';

interface Props {
  setShowDropDown: React.Dispatch<React.SetStateAction<boolean>>;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

const SubscribeButton: React.FC<Props> = ({ setShowDropDown, setOpen }) => {
  const userData = useRecoilValue<User | undefined>(user);

  return (
    <ShouldRender
      check={
        !isPlatformSubscriptionActive(userData) &&
        getGlobalCountry()?.name?.toLowerCase() === 'india'
      }
    >
      <div className='px-5 w-full'>
        <button
          onClick={() => {
            setShowDropDown(false);
            if (typeof window !== 'undefined') {
              window.open('https://zbrlrn.com/mWgHA', '_blank');
            }
            setOpen(false);
          }}
          className=' flex items-center justify-center  w-full bg-gradient-to-br from-[#593A1A] to-[#D3A984] rounded-lg '
        >
          <div
            className='flex items-center justify-center gap-2 p-2 w-full m-px rounded-lg'
            style={{
              background:
                'linear-gradient(152deg, #1B1815 9.93%, #1E1A17 90.07%)',
            }}
          >
            <CrownIcon className='w-6 h-6' />
            <p className='text-xs/4 text-[#D3A984] font-medium'>
              Subscribe For Unlimited Access
            </p>
          </div>
        </button>
      </div>
    </ShouldRender>
  );
};

export default SubscribeButton;
